export enum InvoiceStatusEnum {
	Paid = 1,
	PartiallyPaid = 2,
	ToPay = 3,
	Retracted = 4,
	Fulfilled = 5,
	AddedAmount = 6,
	NotBilled = 7
}

export enum InvoiceTypeEnum {
	TermBill = 1,
	ChangeAmount = 2,
	ChangeInterest = 3,
	DebtCollection = 4,
	FulfillmentBill = 5,
	DebtCollectionReturn = 6,
}

export const InvoiceStatusToString = (id: number | undefined) => {
	switch (id) {
		case 1:
			return "Betalt";
		case 2:
			return "Delbetalt";
		case 3:
			return "Ubetalt";
		case 4:
			return "Tilbakeført";
		case 5:
			return "Oppgjørsfaktura";
		case 6:
			return "Lagt til lånesaldo";
		case 7:
			return "Ufakturert";
		default:
			return "Ubetalt";
	}
};
